export default "__VITE_ASSET__9b0cffe1__"